"use client"

import React from "react";
import LogoutIcon from '@mui/icons-material/Logout';
import { signOut } from "next-auth/react";
import { redirect } from "next/navigation";
import { capitalizeFirst } from "@/app/util/common/capitalize";
import { useTheme } from "@/app/util/theme/themeProvider";

const NavbarProfile = (props: any) => {
    const { theme, toggleTheme } = useTheme();
    const isLight = theme === "light";

    const signOutUser = () => {
        signOut().then(() => {
            redirect("api/auth/login")
        });
    }

    return (
        <span>
            <div className={`policy-buttons policy-buttons-profile ${(props.hidden) ? "nav-items-hidden" : ""}`}>
                <a href="/policy/privacy" className="privacy-policy-button">Privacy Policy</a>
                <a href="/policy/terms" className="privacy-policy-button">Terms</a>
                <p className="version">V1.4</p>
            </div>
            <div className={`navbar-profile-container ${(props.hidden) ? "nav-profile-hidden" : ""}`}>
                <img src={props.profileImage} alt="profile picture"></img>
                <div>
                    <span>{capitalizeFirst(props.profileName)}</span>
                    <span className="header-theme-toggle-wrapper">
                        <div className="header-theme-toggle">
                            <svg className="moon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25"><path d="M23.9524 17.5172C22.8559 17.8316 21.6976 18 20.5 18C13.5964 18 8 12.4036 8 5.5C8 3.71558 8.3739 2.01849 9.04761 0.482849C3.82315 1.98102 0 6.79401 0 12.5C0 19.4036 5.59644 25 12.5 25C17.6192 25 22.0196 21.9227 23.9524 17.5172Z"></path></svg>
                            <label className="toggle-switch">
                                <input type="checkbox" checked={isLight} onChange={toggleTheme} />
                                <span className="toggle-switch-slider"></span>
                            </label>
                            <svg className="sun" viewBox="0 0 16 16" version="1.1" id="Layer_1_1_" xmlns="http://www.w3.org/2000/svg"><circle cx="8.5" cy="7.5" r="4.5"></circle><rect height="2" width="1" x="8"></rect><rect height="2" width="1" x="8" y="13"></rect><rect height="1" width="2" x="14" y="7"></rect><rect height="1" width="2" x="1" y="7"></rect><rect height="2" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -4.7175 12.8033)" width="1" x="12.596" y="11.096"></rect><rect height="2" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -0.9099 3.6109)" width="1" x="3.404" y="1.904"></rect><rect height="1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -7.4099 6.3033)" width="2" x="2.904" y="11.596"></rect><rect height="1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 1.7823 10.1107)" width="2" x="12.096" y="2.404"></rect></svg>
                        </div>
                    </span>
                </div>
                <button onClick={() => signOutUser()}>
                    <LogoutIcon></LogoutIcon>
                </button>
            </div>
        </span>
    );
};

export default NavbarProfile;